import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import BuySellComponent from './BuySellComponent';
import { buyValue, orderTypes } from 'apex-web/lib/constants/sendOrder/orderEntryFormConstants';
import { openModal, MODAL_TYPES } from 'apex-web/lib/redux/actions/modalActions';

const BuySellComponentForm = reduxForm({
  form: 'buySell',
  onSubmit: (payload, dispatch) => {
    dispatch(openModal(MODAL_TYPES.RETAIL_SUBMIT_ORDER));
  }
})(BuySellComponent);

const mapStateToProps = () => ({
  initialValues: {
    side: buyValue,
    amountRadio: 'custom',
    price: '',
    quantity: '',
    fee: '0',
    orderType: orderTypes.limit.displayName,
    responseMessage: ''
  }
});

export default connect(mapStateToProps)(BuySellComponentForm);
